import React, { useEffect, useState } from 'react';
import '../../index.scss';
import { useSelector } from 'react-redux';
import { getUserInfoRedux } from 'reducers/shareData/selector';
import MenuIcon from '@material-ui/icons/Menu';
import Menu, { IMenu } from '../Menu';

const Header = (props: IMenu): JSX.Element => {
  const { guest = undefined } = props;
  const [isGuest, setIsGuest] = useState(guest);
  const { user } = useSelector(getUserInfoRedux);

  const [mobileMenuShow, setMobileMenuShow] = useState<boolean>(false);

  const handleMobile = () => {
    setMobileMenuShow(!mobileMenuShow);
  };

  return (
    <>
      <div className="header-area">
        <div className="header-title">
          <span className="title">快遞業界整合資訊平台</span>
          <span className="user-name">歡迎 {user.name || ''}</span>
        </div>
        <div className="menuIcon">
          <MenuIcon onClick={handleMobile} />
        </div>
      </div>
      <div className={mobileMenuShow ? 'menu-mobile' : 'menu-area'}>
        <Menu guest={isGuest} />
      </div>
    </>
  );
};

export default Header;
